<template>
  <div>
    <CardEdit
      ref="formExtra"
      formName="formExtra"
      :source-data="sourceDataExtra"
      :schema="EXTRA_INFO_SCHEMA"
      layout="horizontal"
      :labelCol="labelColExtra"
      :wrapperCol="wrapperColExtra"
      :defaultColXs="defaultColXs"
      :defaultColSm="defaultColSm"
      :defaultColMd="defaultColMd"
      :defaultColLg="defaultColLg"
      :defaultColXl="defaultColXl"
    ></CardEdit>
  </div>
</template>
<script>
import { CardEdit } from 'lxfintech-fe'
import mixin from './mixin'
import { addCuntomerDetails } from '../api'
import { getFieldsErrorList } from 'utils/util'
export default {
  props: ['code'],
  components: {
    CardEdit,
  },
  mixins: [mixin],
  name: 'ExtralInfo',
  data() {
    return {
      checkboxList: [],
      tableRow: {},
      filters: [],
      destroyOnClose: true,
      activeKey: [1, 2],
      basicOperating: true, // 企业基本信息是否可操作
      businessList: [], //业务类型
      regionOptionList: [], //大区/模式 optionList
    }
  },

  mounted() {
    this.initialData()
    this.coopTimeList()
  },
  methods: {
    // 初始化额外信息
    initialData() {
      const formatData = {
        isExpiryRisk: '2',
        isExpiry: '2',
        establishYear: '',
        coopTime: '0',
      }
      Object.keys(this.sourceDataExtra).forEach(
        k => (this.sourceDataExtra[k] = formatData[k] || ''),
      )
    },
    // 合作年限
    coopTimeList() {
      for (var i = 0; i < 51; i++) {
        this.EXTRA_INFO_SCHEMA.coopTime.optionList.push({
          label: i + '',
          value: i + '',
        })
      }
    },

    // 校验 - 企业额外信息
    async validateFormExtra() {
      try {
        const values = await this.$refs.formExtra.handleSubmit()
        const passed = !!values
        if (passed) {
          // 校验通过，返回数据
          this.clearFieldsError()
          for (let key in this.sourceDataExtra) {
            this.sourceDataExtra[key] = values[key]
          }
          this.sourceDataExtra.companyCode = this.code
          return this.sourceDataExtra
        }
      } catch (err) {
        console.log(err)
      }
      // 校验未通过，获取未通过的项
      this._getFieldsErrorsList()
      return false
    },
    // 保存 - 企业额外信息
    async handleSubmitExtra() {
      try {
        if (this.code) {
          var data = await this.validateFormExtra()
          if (data) {
            const { message } = await addCuntomerDetails(data)
            this.$notification.success({
              message: '提示',
              description: message,
            })
          }
        } else {
          this.$message.warning(`请先设置企业基本信息`)
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 获取未通过校验的项
    _getFieldsErrorsList() {
      const $formExtra = this.$refs.formExtra
      const formExtraFieldsError = getFieldsErrorList(
        $formExtra.getFieldsError(),
        'formExtra',
      )
      this.$emit('setFieldErrors', formExtraFieldsError)
    },
    clearFieldsError() {
      this.$emit('setFieldErrors', [])
    },
    reset() {
      this.$refs.formExtra.handleReset()
    },
  },
}
</script>
<style scoped>
.margin-left-20 {
  margin-left: 20px;
}
.client-center-home
  >>> .ant-collapse
  > .ant-collapse-item
  > .ant-collapse-header {
  line-height: 30px;
}
</style>
